<template>
  <div class="mb-6">
    <v-layout class="inv-top-header mb-4">
      <v-flex>
        <h2 class="title">Units Used per Cross Sell</h2>
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        class="mx-0 mb-0"
        text
        small
        :disabled="loading || items.length === 0 || !no_data.includes(dateError)"
        @click="exportCSV"
        ><v-icon class="mr-1">cloud_download</v-icon> CSV</v-btn
      >
    </v-layout>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :disable-pagination="true"
        :loading="loading"
        loader-height="2"
        hide-default-footer
        class="elevation-1 table-org"
        mobile-breakpoint="100"
      >
        <template v-slot:item="{item}">
          <tr class="items-body-row">
            <td>
              <span v-if="!no_data.includes(item.cross_sell_name)">{{ item.cross_sell_name }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.cross_sell_unit)">{{ item.cross_sell_unit }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.amount)">{{ item.amount }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
        </template>
        <template
          slot="no-data"
          v-if="error_code == 404 || error_code == 500"
        >
          <v-btn color="primary" @click="addResServReport()">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
  name: "ResidentialCrossSellsReport",
  props: ['start_date', 'end_date', 'dateError'],
  data: () => ({
    no_data: [null, "", undefined, "null"],
    headers: [
      {
        text: "Cross Sell",
        value: "cross_sell_name",
        sortable: false,
        align: "left",
      },
      {
        text: "Unit",
        value: "cross_sell_unit",
        sortable: false,
        align: "left",
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false,
        align: "left",
      }
    ],
    items: [],
    options: {},
    totalItems: 0,
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      page: 0,
      column: 0,
      dir: "asc"
    },
    loading: false,
    error_code: "",
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong..."
  }),
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      if(this.no_data.includes(this.dateError)) {
        this.loading = true;
        let body = {
          start_date: this.start_date,
          end_date: this.end_date
        }

        ApiService.get("/inventory_tracking/inventory_log/per_cross_sell", body)
          .then(response => {
            this.items = response.data.log_per_cross_sell
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
          })
      }
    },
    exportCSV() {
      if(this.no_data.includes(this.dateError)) {
        try {
          let csvContent = ""
          let headers = '"Cross Sell","Unit","Amount"'
          let csvData = []
          this.items.forEach(item => {
            let row = {
              cross_sell_name: !this.no_data.includes(item.cross_sell_name)
                ? `"${item.cross_sell_name}"`
                : `""`,
              cross_sell_unit: !this.no_data.includes(item.cross_sell_unit)
                ? `"${item.cross_sell_unit}"`
                : `""`,
              amount: !this.no_data.includes(item.amount)
                ? `"${item.amount}"`
                : `""`,
            }
            csvData.push(row)
          });

          csvContent += [
            headers,
            ...csvData.map(item => Object.values(item).join(","))
          ].join("\n").replace(/(^\[)|(\]$)/gm, "")

          const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
          const url = URL.createObjectURL(data)
          const link = document.createElement("a");
          link.setAttribute("href", url);
          let fileName = `Units Used per Cross Sell - from ${this.start_date} to ${this.end_date}.csv`
          link.setAttribute(
            "download",
            fileName
          );
          link.click()
        }
        catch (error) {
          this.vEmit({
            name: "notification", 
            data: {
              status: "error",
              text: "Oops something went wrong..."
            }
          })
        }
      }
    }
  },
  computed: {
    dateFilters() {
      return `${this.start_date}-${this.end_date}`
    }
  },
  watch: {
    'dateFilters': function (val) {
      this.initialize()
    }
  }
};
</script>